import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { NumberService } from '@call-tracking/services/NumberService';
import ItemForm from '@call-tracking/components/modal-numbers-create-update-form';
import i18n from '@app/plugins/i18n';

class NumberModalService extends ModalService {
  constructor() {
    super(NumberService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('call-tracking.number.modal.remove.content', {
        number: `<strong>${item.number}</strong>`
      })
    });
  }

  create() {
    return this.$open({
      title: i18n.t('shared.component.modal.create'),
      width: this.size.confirm,
      render: h =>
        h(ItemForm, {
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new NumberModalService();
export { instance as NumberModalService };
